"use client";

import { FunctionComponent, useState, useEffect } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { handlingUrlParams } from "Utils/AppUtils";
import AdminServices from "services/admin-services";
import { setToaster } from "common/toastStore";
import { Sidebar } from "primereact/sidebar";

interface TableDataProps {
  customerId: number;
  jobId: number;
  statusID: number;
}

const JobTable: FunctionComponent<TableDataProps> = ({
  customerId,
  jobId,
  // statusID,
}) => {
  const [data, setData] = useState<any[]>([]);
  const [showLoanModel, setShowLoanModel] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [lazyParams, setLazyParams] = useState({
    first: 0,
    rows: 10,
    page: 1,
  });

  useEffect(() => {
    loadLazyData();
  }, [lazyParams]);

  const loadLazyData = () => {
    setLoading(true);
    AdminServices.getJobLoans(
      handlingUrlParams({
        JobId: jobId,
        PageNumber: lazyParams.page,
        PageSize: lazyParams.rows,
      })
    )
      .then((response: any) => {
        const parsedHeaders = JSON.parse(response.headers["x-pagination"]);
        setData(response.data);
        setTotalRecords(parsedHeaders.TotalCount);
        setLoading(false);
      })
      .catch((e: Error) => {
        console.error(e);
        setLoading(false);
      });
  };

  // Format date with timestamp
  const formatDateTime = (value: string) => {
    if (!value) return "";
    const date = new Date(value);
    return date.toLocaleString("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    });
  };

  // Date column template
  const dateBodyTemplate = (rowData: any, field: string) => {
    return formatDateTime(rowData[field]);
  };

  // const handleUpload = async (event: any) => {
  //   const file = event.files[0];
  //   if (!file) return;

  //   const formData = new FormData();
  //   formData.append("File", file);

  //   setLoading(true);
  //   try {
  //     await AdminServices.uploadJob(
  //       jobId,
  //       handlingUrlParams({ customerId }),
  //       formData
  //     );

  //     setToaster({
  //       severity: "success",
  //       summary: "Success",
  //       detail: `File uploaded successfully for loan `,
  //     });
  //   } catch (error: any) {
  //     setToaster({
  //       severity: "error",
  //       summary: "Upload Failed",
  //       detail: error?.message || "Something went wrong while uploading file",
  //     });
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // const handleDeleteRow = (rowData: { id: any; jobId: number }) => {
  //   confirmDialog({
  //     message: "Are you sure you want to delete this loan?",
  //     header: "Confirmation",
  //     icon: "pi pi-exclamation-triangle",
  //     acceptLabel: "Yes",
  //     rejectLabel: "No",
  //     accept: async () => {
  //       const updatedData = data.filter(
  //         (item: { id: any }) => item.id !== rowData.id
  //       );

  //       setLoading(true);
  //       try {
  //         await AdminServices.updateJob(
  //           rowData?.jobId,
  //           handlingUrlParams({ customerId }),
  //           updatedData
  //         );
  //         setData(updatedData);
  //         setToaster({
  //           severity: "success",
  //           summary: "Success",
  //           detail: `Deleted loan successfully!`,
  //         });
  //       } catch (e: any) {
  //         setToaster({
  //           severity: "error",
  //           summary: "Error Message",
  //           detail: `${e}`,
  //         });
  //       } finally {
  //         setLoading(false);
  //       }
  //     },
  //     reject: () => {
  //       // Do nothing if rejected
  //     },
  //   });
  // };

  // const handleAddLoan = async (newLoan: { loanNumber: string }) => {
  //   const newEntry = {
  //     id: Math.max(...data.map((d: { id: any }) => d.id), 0) + 1,
  //     jobId: data[0]?.jobId || jobId,
  //     loanNumber: newLoan.loanNumber,
  //   };

  //   const updatedData = [...data, newEntry];

  //   setLoading(true);
  //   try {
  //     setData(updatedData);

  //     await AdminServices.updateJob(
  //       newEntry.jobId,
  //       handlingUrlParams({ customerId }),
  //       updatedData
  //     );

  //     setToaster({
  //       severity: "success",
  //       summary: "Success",
  //       detail: "New loan added successfully!",
  //     });
  //     setShowLoanModel(false);
  //   } catch (error: any) {
  //     setToaster({
  //       severity: "error",
  //       summary: "Add Loan Failed",
  //       detail: error?.message || "Something went wrong while adding loan",
  //     });
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // Action buttons for each row
  // const actionTemplate = (rowData: any) => {
  //   return (
  //     <div className="flex gap-2">
  //       <Button
  //         icon="pi pi-trash"
  //         style={{
  //           background: "red",
  //           border: "1px solid red",
  //           padding: "5px 10px",
  //           width: "auto",
  //         }}
  //         className="p-button-sm"
  //         onClick={() => handleDeleteRow(rowData)}
  //         // disabled={statusID === 18}
  //       />
  //     </div>
  //   );
  // };

  // const handleReorder = (e: any) => {
  //   setData(e.value);
  //   console.log(e);
  //   // Optionally: call your API to persist new order
  //   // await AdminServices.updateJob(jobId, handlingUrlParams({ customerId }), e.value);
  // };

  const onPage = (event: any) => {
    setLazyParams({
      ...lazyParams,
      first: event.first,
      rows: event.rows,
      page: event.page + 1,
    });
  };

  const handleReorder = async (e: any) => {
    const reorderedPage = e.value;

    const start = lazyParams.first;
    const end = lazyParams.first + lazyParams.rows;

    const before = data.slice(0, start);
    const after = data.slice(end);
    const merged = [...before, ...reorderedPage, ...after];

    // Update processOrder sequentially (optional)
    const updated = merged.map((item) => ({
      ...item,
    }));

    setData(updated);
    console.log("✅ Full reordered dataset:", updated);

    try {
      await AdminServices.updateJob(
        jobId,
        handlingUrlParams({ customerId }),
        updated
      );
      setToaster({
        severity: "success",
        summary: "Success",
        detail: "Reordered successfully!",
      });
    } catch (error: any) {
      setToaster({
        severity: "error",
        summary: "Reorder Failed",
        detail: error?.message || "Failed to save new order",
      });
    }
  };

  return (
    <div className="card">
      <div className="flex justify-between items-center py-3">
        <h3 className="text-lg font-semibold mb-3">Loan Numbers</h3>
        <div className=" flex items-center">
          {/* <FileUpload
            mode="basic"
            name="file"
            auto
            customUpload
            chooseLabel="Upload"
            uploadHandler={(e) => handleUpload(e)}
            className="p-button-success mx-4"
            // disabled={statusID === 18}
          />
          <Button
            onClick={() => {
              setShowLoanModel(true);
            }}
            label={"Add Loan"}
            className="p-button-success p-button-outlined"
            style={{ padding: "5px 15px", fontSize: 12 }}
          /> */}
        </div>
      </div>
      <DataTable
        reorderableRows
        onRowReorder={handleReorder}
        value={data}
        loading={loading}
        lazy
        paginator
        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
        totalRecords={totalRecords}
        rows={lazyParams.rows}
        first={lazyParams.first}
        onPage={onPage}
        rowsPerPageOptions={[10, 20, 50]}
        stripedRows
        responsiveLayout="scroll"
        emptyMessage="No loan numbers found"
      >
        {/* <Column rowReorder style={{ width: "3rem" }} />
        <Column field="id" header="ID" style={{ width: "10%" }} />
        <Column field="jobId" header="Job ID" style={{ width: "20%" }} /> */}
        <Column
          field="loanNumber"
          header="Loan Number"
          style={{ width: "20%" }}
        />
        <Column field="status" header="Status" style={{ width: "20%" }} />
        <Column
          field="createdDate"
          header="Added Date"
          body={(rowData) => dateBodyTemplate(rowData, "createdDate")}
          style={{ width: "20%" }}
        />
        <Column
          field="lastUpdatedDate"
          header="Last Updated"
          body={(rowData) => dateBodyTemplate(rowData, "lastUpdatedDate")}
          style={{ width: "20%" }}
        />
        <Column
          field="timeTaken"
          header="Time Taken In Seconds"
          style={{ width: "20%" }}
        />
        {/* <Column
          header="Actions"
          body={actionTemplate}
          style={{ width: "30%" }}
        /> */}
      </DataTable>
      {/* {loading ? <Loader /> : null} */}
      <Sidebar
        visible={showLoanModel}
        position="right"
        style={{ minHeight: 500, width: 400 }}
        onHide={() => setShowLoanModel(false)}
      >
        {/* <AddLoan
          onClose={() => setShowLoanModel(false)}
          onAddLoan={handleAddLoan}
        /> */}
      </Sidebar>
    </div>
  );
};

export default JobTable;
